import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = (theme) => ({
  maxWidth: 400,
  width: "105%",
  background: theme.palette.quizPopap.quizeGraf,
  py: 2,
  px: "16px",
  borderRadius: "20px",
  boxSizing: "border-box",
});

export const titleStyle: SxProps<Theme> = (theme) => ({
  fontWeight: 600,
  color: theme.palette.quizPopap.quizText,
  mb: 1,
  ml: "5px",
  fontSize: "12px",
  textAlign: "left",
});

export const legendContainerStyle: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  mb: -1,
  justifyContent: "flex-start",
};

export const legendItemStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const legendBoxStyle = (gradient: string): SxProps<Theme> => ({
  width: 6,
  height: 6,
  borderRadius: "6px",
  background: gradient,
});

export const legendTextStyle: SxProps<Theme> = {
  fontSize: "10px",
  color: "#9CA3AF",
};

export const chartWrapperStyle: SxProps<Theme> = {
  width: "100%",
  height: 145,
};
